import { useState as n, useRef as e, useCallback as t, useEffect as o, useLayoutEffect as r } from "react";
import { flushSync as i } from "react-dom";
import l from "raf";
import a from "tiny-warning";

function c() {
  return c = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
      }
    }

    return n;
  }, c.apply(this, arguments);
}

function u(n, e) {
  if (null == n) return {};
  var t,
      o,
      r = {},
      i = Object.keys(n);

  for (o = 0; o < i.length; o++) {
    e.indexOf(t = i[o]) >= 0 || (r[t] = n[t]);
  }

  return r;
}

var d = function d() {};

function s(n) {
  return null != n && n.current ? n.current.scrollHeight : (a(!0, "useCollapse was not able to find a ref to the collapse element via `getCollapseProps`. Ensure that the element exposes its `ref` prop. If it exposes the ref prop under a different name (like `innerRef`), use the `refKey` property to change it. Example:\n\n{...getCollapseProps({refKey: 'innerRef'})}"), "auto");
}

var f = function f() {
  var n = arguments;
  return function () {
    var e = arguments;
    return [].slice.call(n).forEach(function (n) {
      return n && n.apply(void 0, [].slice.call(e));
    });
  };
};

function p(n, e) {
  if (null != n) if ("function" == typeof n) n(e);else try {
    n.current = e;
  } catch (t) {
    throw new Error('Cannot assign value "' + e + '" to ref "' + n + '"');
  }
}

var h = "undefined" != typeof window ? r : o,
    v = !1,
    g = 0,
    m = function m() {
  return ++g;
},
    x = ["duration", "easing", "collapseStyles", "expandStyles", "onExpandStart", "onExpandEnd", "onCollapseStart", "onCollapseEnd", "isExpanded", "defaultExpanded", "hasDisabledAnimation"],
    y = ["disabled", "onClick"],
    E = ["style", "onTransitionEnd", "refKey"];

function b(r) {
  var g,
      b,
      C = void 0 === r ? {} : r,
      w = C.duration,
      S = C.easing,
      k = void 0 === S ? "cubic-bezier(0.4, 0, 0.2, 1)" : S,
      O = C.collapseStyles,
      P = void 0 === O ? {} : O,
      T = C.expandStyles,
      D = void 0 === T ? {} : T,
      K = C.onExpandStart,
      j = void 0 === K ? d : K,
      N = C.onExpandEnd,
      z = void 0 === N ? d : N,
      A = C.onCollapseStart,
      H = void 0 === A ? d : A,
      I = C.onCollapseEnd,
      M = void 0 === I ? d : I,
      R = C.isExpanded,
      q = C.defaultExpanded,
      B = void 0 !== q && q,
      V = C.hasDisabledAnimation,
      _ = void 0 !== V && V,
      F = u(C, x),
      G = function (r, i) {
    var l = n(i || !1),
        c = l[0],
        u = l[1],
        d = e(null != r),
        s = d.current ? r : c,
        f = t(function (n) {
      d.current || u(n);
    }, []);
    return o(function () {
      a(!(d.current && null == r), "useCollapse is changing from controlled to uncontrolled. useCollapse should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."), a(!(!d.current && null != r), "useCollapse is changing from uncontrolled to controlled. useCollapse should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop.");
    }, [r]), [s, f];
  }(R, B),
      J = G[0],
      L = G[1],
      Q = function (e) {
    var t = v ? m() : null,
        r = n(t),
        i = r[0],
        l = r[1];
    return h(function () {
      null === i && l(m());
    }, []), o(function () {
      !1 === v && (v = !0);
    }, []), null != i ? String(i) : void 0;
  }(),
      U = e(null);

  g = U, b = function b(n) {}, "production" !== process.env.NODE_ENV && (b = function b(n) {
    if (null != n && n.current) {
      var e = window.getComputedStyle(n.current),
          t = e.paddingTop,
          o = e.paddingBottom;
      a(!(t && "0px" !== t || o && "0px" !== o), "react-collapsed: Padding applied to the collapse element will cause the animation to break and not perform as expected. To fix, apply equivalent padding to the direct descendent of the collapse element.");
    }
  }), o(function () {
    b(g);
  }, [g]);

  var W,
      X,
      Y,
      Z = (F.collapsedHeight || 0) + "px",
      $ = {
    display: "0px" === Z ? "none" : "block",
    height: Z,
    overflow: "hidden"
  },
      nn = n(J ? {} : $),
      en = nn[0],
      tn = nn[1],
      on = function on(n) {
    i(function () {
      tn(n);
    });
  },
      rn = function rn(n) {
    on(function (e) {
      return c({}, e, n);
    });
  };

  function ln(n) {
    if (_) return {};

    var e = w || function (n) {
      if (!n || "string" == typeof n) return 0;
      var e = n / 36;
      return Math.round(10 * (4 + 15 * Math.pow(e, .25) + e / 5));
    }(n);

    return {
      transition: "height " + e + "ms " + k
    };
  }

  W = function W() {
    l(J ? function () {
      j(), rn(c({}, D, {
        willChange: "height",
        display: "block",
        overflow: "hidden"
      })), l(function () {
        var n = s(U);
        rn(c({}, ln(n), {
          height: n
        }));
      });
    } : function () {
      H();
      var n = s(U);
      rn(c({}, P, ln(n), {
        willChange: "height",
        height: n
      })), l(function () {
        rn({
          height: Z,
          overflow: "hidden"
        });
      });
    });
  }, X = [J], Y = e(!0), o(function () {
    if (!Y.current) return W();
    Y.current = !1;
  }, X);

  var an = function an(n) {
    if (n.target === U.current && "height" === n.propertyName) if (J) {
      var e = s(U);
      e === en.height ? on({}) : rn({
        height: e
      }), z();
    } else en.height === Z && (on($), M());
  };

  return {
    getToggleProps: function getToggleProps(n) {
      var e = void 0 === n ? {} : n,
          t = e.disabled,
          o = void 0 !== t && t,
          r = e.onClick,
          i = void 0 === r ? d : r,
          l = u(e, y);
      return c({
        type: "button",
        role: "button",
        id: "react-collapsed-toggle-" + Q,
        "aria-controls": "react-collapsed-panel-" + Q,
        "aria-expanded": J,
        tabIndex: 0,
        disabled: o
      }, l, {
        onClick: o ? d : f(i, function () {
          return L(function (n) {
            return !n;
          });
        })
      });
    },
    getCollapseProps: function getCollapseProps(n) {
      var e,
          t = void 0 === n ? {} : n,
          o = t.style,
          r = void 0 === o ? {} : o,
          i = t.onTransitionEnd,
          l = void 0 === i ? d : i,
          a = t.refKey,
          s = void 0 === a ? "ref" : a,
          h = u(t, E);
      return c({
        id: "react-collapsed-panel-" + Q,
        "aria-hidden": !J
      }, h, ((e = {})[s] = function () {
        var n = [].slice.call(arguments);
        return n.every(function (n) {
          return null == n;
        }) ? null : function (e) {
          n.forEach(function (n) {
            p(n, e);
          });
        };
      }(U, h[s]), e.onTransitionEnd = f(an, l), e.style = c({
        boxSizing: "border-box"
      }, r, en), e));
    },
    isExpanded: J,
    setExpanded: L
  };
}

export { b as default };